module.exports = __webpack_public_path__ + "img/mv_logo.9d9f1c63.svg";